import { IBaseFormProps } from "../interfaces";
import BaseForm from "./BaseForm";
import FeaturenodesForm from "./FeaturenodesForm";

interface IFormData {
  modelName: string;
  form: (props: IBaseFormProps) => JSX.Element;
}

/**
 * Form List
 * Add a form and add it to this list to be auto-selected by the create/update indices
 */
const formList: IFormData[] = [
  {
    modelName: "featurenodes",
    form: FeaturenodesForm,
  },
];

export const getForm = (
  modelName: string,
): ((props: IBaseFormProps) => JSX.Element) => {
  const form =
    formList.find((form) => form.modelName === modelName)?.form || BaseForm;
  return form;
};
